export default __webpack_public_path__ + "static/media/v2-story-2.4360343e.jpg";